import React, { useState } from 'react';
import Layout from './Layout';

const Quotation = () => {
  const [formData, setFormData] = useState({
    customerName: '',
    phone: '',
    email: '',
    systemSize: '',
    panelType: 'Monocrystalline',
    inverterType: 'String',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Quotation generated successfully! (PDF will be downloaded)');
  };

  return (
    <Layout>
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white">Generate Quotation</h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">Create professional solar quotations for your customers</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-white dark:bg-slate-900/50 rounded-2xl shadow-sm dark:shadow-xl border border-slate-200 dark:border-slate-800 p-6 sm:p-8 transition-colors">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">Customer Name *</label>
              <input
                type="text"
                name="customerName"
                value={formData.customerName}
                onChange={handleChange}
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
                required
              />
            </div>
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">Phone *</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
                required
              />
            </div>
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
              />
            </div>
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">System Size (kW) *</label>
              <input
                type="number"
                name="systemSize"
                value={formData.systemSize}
                onChange={handleChange}
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
                required
              />
            </div>
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">Panel Type</label>
              <select
                name="panelType"
                value={formData.panelType}
                onChange={handleChange}
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
              >
                <option>Monocrystalline</option>
                <option>Polycrystalline</option>
                <option>Thin Film</option>
              </select>
            </div>
            <button
              type="submit"
              className="w-full px-6 py-3 bg-[#10B981] hover:bg-emerald-600 text-white font-bold rounded-xl shadow-lg shadow-emerald-500/20 transition-all text-sm mt-4"
            >
              Generate Quotation
            </button>
          </form>
        </div>

        <div className="bg-white dark:bg-slate-900/50 rounded-2xl shadow-sm dark:shadow-xl border border-slate-200 dark:border-slate-800 p-6 sm:p-8 transition-colors">
          <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-4">Quotation Preview</h3>
          <div className="bg-slate-50 dark:bg-slate-800/60 rounded-xl p-6 text-sm text-slate-500 dark:text-slate-400 border border-slate-200/60 dark:border-slate-700/60">
            <p className="text-center font-semibold text-slate-600 dark:text-slate-300">Enter customer details and click "Generate Quotation"</p>
            <p className="text-center text-xs mt-1 text-slate-400 dark:text-slate-500">A branded PDF document will be compiled instantly</p>
            <div className="mt-6 border-t border-slate-200 dark:border-slate-700/80 pt-4">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400">Sample Quotation includes:</p>
              <ul className="text-xs text-slate-500 dark:text-slate-400 list-disc list-inside mt-2 space-y-1">
                <li>Customer information</li>
                <li>System specifications & engineering diagram</li>
                <li>Comprehensive cost breakdown</li>
                <li>Payment terms & subsidies</li>
                <li>Tier-1 warranty details</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Quotation;